import antd, {Menu} from 'antd';
import {TableCard} from 'components';
import {useAccessLevel} from 'hooks/useAccessLevel';
import {MenuInfo} from 'rc-menu/lib/interface';
import React from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router-dom';
import styled from 'styled-components';
import {ApiSettings} from './ApiSettings';
import {AuthorizedUsers} from './AuthorizedUsers';
import {EmailNotifications} from './EmailNotifications';
import {GeneralSettings} from './GeneralSettings';
import {LegalDocs} from './LegalDocs';
import {MasterAccountInfo} from './MasterAccountInfo';
import {SecuritySettings} from './SecuritySettings';
import {Webhooks} from './Webhooks';

const {Sider} = antd.Layout;

const Layout = styled(antd.Layout)`
  && {
    padding-top: 16px;
    padding-bottom: 16px;
    background: #fff;
    flex: 1;
    min-height: 75vh;
  }
`;

const Content = styled(antd.Layout.Content)`
  && {
    min-height: 280px;
    padding: 8px 40px;
  }
`;

export const Settings: React.FC<RouteComponentProps> = ({match, history, location}) => {
  const {isMasterOnly} = useAccessLevel();
  const handleMenuClick = ({key}: MenuInfo) => {
    history.push(String(key));
  };
  return (
    <TableCard>
      <Layout>
        <Sider theme="light">
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            onClick={handleMenuClick}
            style={{height: '100%'}}>
            {isMasterOnly && <Menu.Item key={`${match.url}/account`}>Account</Menu.Item>}
            <Menu.Item key={match.url}>Profile</Menu.Item>
            {isMasterOnly && <Menu.Item key={`${match.url}/legal-docs`}>Legal documents</Menu.Item>}
            {isMasterOnly && <Menu.Item key={`${match.url}/emails`}>Email notifications</Menu.Item>}
            {isMasterOnly && <Menu.Item key={`${match.url}/security`}>Security</Menu.Item>}
            {isMasterOnly && <Menu.Item key={`${match.url}/users`}>Authorized users</Menu.Item>}
            {isMasterOnly && <Menu.Item key={`${match.url}/webhooks`}>Webhooks</Menu.Item>}
            {isMasterOnly && <Menu.Item key={`${match.url}/api-settings`}>API Settings</Menu.Item>}
          </Menu>
        </Sider>
        <Content>
          <Switch>
            {isMasterOnly && <Route path={`${match.path}/account`} component={MasterAccountInfo} />}
            <Route path={match.path} exact component={GeneralSettings} />
            {isMasterOnly && <Route path={`${match.path}/legal-docs`} component={LegalDocs} />}
            {isMasterOnly && <Route path={`${match.path}/emails`} component={EmailNotifications} />}
            {isMasterOnly && <Route path={`${match.path}/security`} component={SecuritySettings} />}
            {isMasterOnly && <Route path={`${match.path}/users`} component={AuthorizedUsers} />}
            {isMasterOnly && <Route path={`${match.path}/webhooks`} component={Webhooks} />}
            {isMasterOnly && <Route path={`${match.path}/api-settings`} component={ApiSettings} />}
          </Switch>
        </Content>
      </Layout>
    </TableCard>
  );
};
